// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"1e7f6d6b","701":"7975e4bd"}[chunkId] + ".chunk.css";
};